<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Tipo servizio assicurativo' : 'Nuova Tipo servizio assicurativo' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-insurance-service-type-form [data]="data"></app-insurance-service-type-form>
</div>
